import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { BuilderBoxAnalysis } from '../../types/SimilarlySituated/BuilderBoxAnalysis.type';
import { SSB_STEP_HEADERS } from '../../utils/ssbStepHeaders';
import OutcomeResultCard from './OutcomeResultCard';
import ResultsNextActions from './ResultsNextActions';
import ResultsPagination from './ResultsPagination';
import SsbStepHeader from './SsbStepHeader';

interface ResultsStepProps {
  analyses: BuilderBoxAnalysis[];
  boxName: string;
  onRefineBox: () => void;
  onBuildNewBox: () => void;
  onBackToCase: () => void;
}

function ResultsStep({ analyses, boxName, onRefineBox, onBuildNewBox, onBackToCase }: ResultsStepProps) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);

  const pageCount = Math.max(1, Math.ceil(analyses.length / pageSize));
  const currentPage = Math.min(page, pageCount);
  const pageAnalyses = analyses.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setPage(1);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '1100px', paddingBottom: '32px' }}>
      <SsbStepHeader
        {...SSB_STEP_HEADERS.Results}
        actions={
          analyses.length > 0 && (
            <ResultsPagination
              page={currentPage}
              pageCount={pageCount}
              pageSize={pageSize}
              totalCount={analyses.length}
              onPageChange={setPage}
              onPageSizeChange={handlePageSizeChange}
            />
          )
        }
      />

      {analyses.length === 0 ? (
        <Typography sx={{ fontSize: '13px', color: '#718096' }}>No results were returned for this run.</Typography>
      ) : (
        pageAnalyses.map((analysis, index) => (
          <OutcomeResultCard key={analysis.id} analysis={analysis} boxName={boxName}>
            {index === pageAnalyses.length - 1 && (
              <ResultsNextActions onRefineBox={onRefineBox} onBuildNewBox={onBuildNewBox} onBackToCase={onBackToCase} />
            )}
          </OutcomeResultCard>
        ))
      )}
    </Box>
  );
}

export default ResultsStep;
